import { OrderStopTypeMap } from "@/constants/order";
import type { RouteStopDto } from "@/api/trips/dto/trip.dto";
import type { TripRouteStop } from "@/types/trip";

export function getStopInfoTitle(stop: TripRouteStop | RouteStopDto): string {
  const title = `${OrderStopTypeMap[stop.type]} #${stop.number} details`;
  const address = stop.facility?.address;

  return address ? `${title}, ${address}` : title;
}

export function getStopVerifyTitle(stop: TripRouteStop | RouteStopDto): string {
  return `Verify information · ${getStopInfoTitle(stop)}`;
}
